import React, { Component } from 'react';
import { Link } from "react-router-dom";

class Portfolio extends Component {
    render() {
        return (

            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h2 className="section-heading text-uppercase">Esempi</h2>
                        <h3 className="section-subheading text-muted">Template di esempio per i vostri siti</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 col-sm-6 portfolio-item">
                        <Link to="/portfolio/youtube">
                            <a className="portfolio-link" >
                                <div className="portfolio-hover">
                                    <div className="portfolio-hover-content">
                                        <i className="fa fa-plus fa-3x" />
                                    </div>
                                </div>
                                <img className="img-fluid" src="examples/assets/demo/sample-screenshots/06.png" alt />
                            </a>
                        </Link>

                        <div className="portfolio-caption">
                            <h4>YouTube Demo</h4>
                            <p className="text-muted">Demo con video di youtube come sfondo</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 portfolio-item">

                        <Link to="/portfolio/freelancer">
                            <a className="portfolio-link" >
                                <div className="portfolio-hover">
                                    <div className="portfolio-hover-content">
                                        <i className="fa fa-plus fa-3x" />
                                    </div>
                                </div>
                                <img className="img-fluid" src="examples/assets/demo/sample-screenshots/07.png" alt />
                            </a>
                        </Link>

                        <div className="portfolio-caption">
                            <h4>Freelancer Demo</h4>
                            <p className="text-muted">Demo di pagina personale adatta ai liberi professionisti</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 portfolio-item">
                    <Link to="/portfolio/activity">
                        <a className="portfolio-link">
                            <div className="portfolio-hover">
                                <div className="portfolio-hover-content">
                                    <i className="fa fa-plus fa-3x" />
                                </div>
                            </div>
                            <img className="img-fluid" src="examples/assets/demo/sample-screenshots/08.png" alt />
                        </a>
                        </Link>
                        <div className="portfolio-caption">
                            <h4>Vetrina Negozio Demo</h4>
                            <p className="text-muted">Demo di pagina adatta a sponsorizare la propria attività</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 portfolio-item">
                    
                    <Link to="/portfolio/landing">
                        <a className="portfolio-link" >
                            <div className="portfolio-hover">
                                <div className="portfolio-hover-content">
                                    <i className="fa fa-plus fa-3x" />
                                </div>
                            </div>
                            <img className="img-fluid" src="examples/assets/demo/sample-screenshots/09.png" alt />
                        </a>
                        </Link>

                        <div className="portfolio-caption">
                            <h4>Vetrina app</h4>
                            <p className="text-muted">Demo di pagina per elenco app o sponsorizzare la propria presenza sui market</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 portfolio-item">
                    <Link to="/portfolio/photography">
                        <a className="portfolio-link" >
                            <div className="portfolio-hover">
                                <div className="portfolio-hover-content">
                                    <i className="fa fa-plus fa-3x" />
                                </div>
                            </div>
                            <img className="img-fluid" src="examples/assets/demo/sample-screenshots/10.png" alt />
                        </a>
                        </Link>
                        <div className="portfolio-caption">
                            <h4>Photographer</h4>
                            <p className="text-muted">Demo per sito professionale per fotografi</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-6 portfolio-item">
                    <Link to="/portfolio/video">
                        <a className="portfolio-link" >
                            <div className="portfolio-hover">
                                <div className="portfolio-hover-content">
                                    <i className="fa fa-plus fa-3x" />
                                </div>
                            </div>
                            <img className="img-fluid" src="examples/assets/demo/sample-screenshots/11.png" alt />
                        </a>
                        </Link>
                        <div className="portfolio-caption">
                            <h4>Demo generica</h4>
                            <p className="text-muted">Pagina generica adattabile alle vostre esigenze</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
};

export default Portfolio